import './index.css'

const PageTitleComponent = ({ value, config={}, events={} }) => {
    return (
        <h2 className="c-PageTitle">{value}</h2>
    )
}

export { PageTitleComponent }